import moment, { Moment } from 'moment'
import { MailSettingsInstance } from '../../../common/types/api/report'
import { defaultThrottleValue } from '../../../common/components/ConvertUom/types/throttleMSHelper'

export const dateToCron = (date: Date): string => {
    const cron = []

    cron.push(date.getMinutes())
    cron.push(date.getHours())
    cron.push(date.getDate())
    cron.push(date.getMonth() + 1) // js counts from 0
    cron.push(date.getDay())

    return cron.join(' ')
}

// return only the date, not the time
export const cronToDate = (cron: string): Moment => {
    if (!cron || cron.includes('*') || cron.includes('@') || cron.includes('/') || cron.includes('-')) {
        return moment()
    }

    if (cron.trim().length) {
        try {
            const cronList = cron.split(' ')
            let date = ''
            date += `${cronList[2]}/`
            date += `${cronList[3]}/`
            date += new Date().getFullYear().toString()
            date += ` ${cronList[1]}:${cronList[0]}`

            const finalMoment = moment(date, 'DD/MM/YYYY HH:mm')
            if (!finalMoment.isValid()) {
                return moment()
            }

            return finalMoment
        } catch (e) {
            return moment()
        }
    } else {
        return moment()
    }
}

export const mailSettingsInstanceValidator = (instance: MailSettingsInstance): string[] => {
    return Object.keys(instance).reduce((result, current) => {
        switch (current) {
            case 'name': {
                if (!instance[current].trim()) {
                    result.push('Must define the schedule name.')
                }

                break
            }
            case 'cron': {
                if (!instance[current].trim()) {
                    result.push('Must define the schedule expression.')
                }

                break
            }
            case 'recipientsUid': {
                if (!instance[current] || !instance[current].length) {
                    result.push('Must define recipients for the schedule')
                }

                break
            }
            case 'throttleAlarm': {
                const minThrottle = defaultThrottleValue
                if (instance['isRuleAlarm']) {
                    if (instance[current] === undefined) {
                        result.push('Must define the throttle period when schedule type is rule')
                    } else if (!Number.isInteger(parseInt(instance[current]))) {
                        result.push('Must define the throttle period as a number when schedule type is rule')
                    } else if (instance[current] < minThrottle) {
                        result.push(
                            `Must define the throttle period equal or higher than ${
                                minThrottle / (1000 * 60) + ' minutes (' + minThrottle / 1000 + ' seconds)'
                            } when schedule type is rule`
                        )
                    }
                }
                break
            }
            case 'ruleId': {
                if(instance['isRuleAlarm']) {
                    if (!instance[current]) {
                        result.push('Must select an Alarm Rule when the schedule type is rule')
                    }
                }
            }
        }

        return result
    }, [] as string[])
}
